module.exports = __webpack_public_path__ + "static/article_bg_wrapper-7534e3208973e8652a8e3b65d5619c63.svg";